var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.sameCondition)?_c('v-col',{staticClass:"color",class:_vm.color},[_c('span',[_vm._v(_vm._s(_vm.color))])]):_c('v-col',{staticClass:"color",class:_vm.color},[_c('span',{staticClass:"grön"},[_vm._v("grön")]),_c('span',{staticClass:"gul"},[_vm._v("gul")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }